/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./AdjustmentDetails.module.css";
import InfoColumn from "./InfoColumn";
import DetailRow from "./DetailRow";
import CommentSection from "./CommentSection";
import ActionButtons from "./ActionButtons";

interface AdjustmentDetailsProps {
  lastUpdated: string;
  periodEnding: string;
  totalBorrowerFees: string;
  cuRetailRate: string;
  protectedLoanAmount: string;
  payRate: string;
  premiumDue: string;
  totalAmount: string;
  adjustmentType: string;
  adjustmentDescription: string;
}

const AdjustmentDetails: React.FC<AdjustmentDetailsProps> = ({
  lastUpdated,
  periodEnding,
  totalBorrowerFees,
  cuRetailRate,
  protectedLoanAmount,
  payRate,
  premiumDue,
  totalAmount,
  adjustmentType,
  adjustmentDescription,
}) => {
  return (
    <section className={styles.container}>
      <div className={styles.content}>
        <InfoColumn
          lastUpdated={lastUpdated}
          totalBorrowerFees={totalBorrowerFees}
          cuRetailRate={cuRetailRate}
          protectedLoanAmount={protectedLoanAmount}
          payRate={payRate}
          premiumDue={premiumDue}
          totalAmount={totalAmount}
        />
        <div className={styles.mainContent}>
          <div className={styles.twoColumnLayout}>
            <div className={styles.leftColumn}>
              <div className={styles.periodInfo}>
                <h2 className={styles.periodEnding}>Period Ending</h2>
                <p className={styles.periodDate}>{periodEnding}</p>
                <div className={styles.detailsContainer}>
                  <DetailRow
                    amount={totalBorrowerFees}
                    iconSrc="https://cdn.builder.io/api/v1/image/assets/TEMP/0efa22a2340cfc679b7f2176894f7c8adde6da6bbfe3b5a645cc6ca37307eec9?placeholderIfAbsent=true&apiKey=56a6c7500c3c464580ff9be9a9daa1d9"
                  />
                  <DetailRow
                    amount={cuRetailRate}
                    iconSrc="https://cdn.builder.io/api/v1/image/assets/TEMP/d03dfde763c0669a5e758dd2c62650102c46fd94aaf320c919750040bd6e444c?placeholderIfAbsent=true&apiKey=56a6c7500c3c464580ff9be9a9daa1d9"
                  />
                  <DetailRow
                    amount={protectedLoanAmount}
                    iconSrc="https://cdn.builder.io/api/v1/image/assets/TEMP/aa9665eed589844c167b4cf62e6fa59c21592e89318367b69303445566507b93?placeholderIfAbsent=true&apiKey=56a6c7500c3c464580ff9be9a9daa1d9"
                  />
                  <DetailRow
                    amount={payRate}
                    iconSrc="https://cdn.builder.io/api/v1/image/assets/TEMP/8a6ab44a080f123ed91a25898f81f08472c869ea560d7839e95c0dda7b9f3827?placeholderIfAbsent=true&apiKey=56a6c7500c3c464580ff9be9a9daa1d9"
                  />
                  <p className={styles.detailAmount}>{totalAmount}</p>
                </div>
              </div>
            </div>
            <div className={styles.rightColumn}>
              <div className={styles.adjustmentInfo}>
                <h2 className={styles.adjustmentType}>
                  Adjustment Type to the Credit Union
                </h2>
                <p className={styles.adjustmentDescription}>
                  {adjustmentDescription}
                </p>
                <CommentSection />
                <ActionButtons />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdjustmentDetails;
